import AxiosConfig from '../utils/AxiosConfig';

class CompanyStatusService {
  // Obtener estados de todas las empresas
  async getCompaniesStatus() {
    try {
      const response = await AxiosConfig.get('/b2b/companies/status');
      return response.data;
    } catch (error) {
      console.error('Error fetching companies status:', error);
      throw error;
    }
  }

  // Obtener estado de una empresa específica
  async getCompanyStatus(companyId) {
    try {
      const response = await AxiosConfig.get(`/b2b/companies/${companyId}/status`);
      return response.data;
    } catch (error) {
      console.error('Error fetching company status:', error);
      throw error;
    }
  }

  // Actualizar estado de una empresa
  async updateCompanyStatus(companyId, statusData) {
    try {
      const response = await AxiosConfig.put(`/b2b/companies/${companyId}/status`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating company status:', error);
      throw error;
    }
  }

  // Obtener empresas por estado
  async getCompaniesByStatus(status) {
    try {
      const response = await AxiosConfig.get(`/b2b/companies/status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching companies by status:', error);
      throw error;
    }
  }

  // Obtener empresas con deuda vencida
  async getOverdueCompanies() {
    try {
      const response = await AxiosConfig.get('/b2b/companies/overdue');
      return response.data;
    } catch (error) {
      console.error('Error fetching overdue companies:', error);
      throw error;
    }
  }

  // Obtener empresas con deuda pendiente
  async getPendingDebtCompanies() {
    try {
      const response = await AxiosConfig.get('/b2b/companies/pending-debt');
      return response.data;
    } catch (error) {
      console.error('Error fetching pending debt companies:', error);
      throw error;
    }
  }

  // Obtener empresas al día
  async getUpToDateCompanies() {
    try {
      const response = await AxiosConfig.get('/b2b/companies/up-to-date');
      return response.data;
    } catch (error) {
      console.error('Error fetching up-to-date companies:', error);
      throw error;
    }
  }

  // Calcular resumen de estados de empresas
  calculateCompaniesSummary(companies) {
    const summary = {
      totalCompanies: companies.length,
      totalAmount: 0,
      totalPaid: 0,
      totalPending: 0,
      upToDate: 0,
      pendingDebt: 0,
      overdueDebt: 0
    };

    companies.forEach(company => {
      summary.totalAmount += company.totalAmount || 0;
      summary.totalPaid += company.paidAmount || 0;
      summary.totalPending += company.pendingAmount || 0;

      switch (company.status) {
        case 'UP_TO_DATE':
          summary.upToDate++;
          break;
        case 'PENDING_DEBT':
          summary.pendingDebt++;
          break;
        case 'OVERDUE_DEBT':
          summary.overdueDebt++;
          break;
      }
    });

    return summary;
  }

  // Obtener estados disponibles
  getCompanyStatuses() {
    return [
      { value: 'UP_TO_DATE', label: 'Al día' },
      { value: 'PENDING_DEBT', label: 'Deuda pendiente' },
      { value: 'OVERDUE_DEBT', label: 'Deuda vencida' }
    ];
  }

  // Obtener color del estado
  getStatusColor(status) {
    switch (status) {
      case 'UP_TO_DATE':
        return 'success';
      case 'PENDING_DEBT':
        return 'warning';
      case 'OVERDUE_DEBT':
        return 'error';
      default:
        return 'default';
    }
  }

  // Obtener texto del estado
  getStatusText(status) {
    switch (status) {
      case 'UP_TO_DATE':
        return 'Al día';
      case 'PENDING_DEBT':
        return 'Deuda pendiente';
      case 'OVERDUE_DEBT':
        return 'Deuda vencida';
      default:
        return 'Desconocido';
    }
  }

  // Validar datos de estado de empresa
  validateCompanyStatusData(statusData) {
    const errors = {};

    if (!statusData.status) {
      errors.status = 'El estado es requerido';
    }

    const validStatuses = ['UP_TO_DATE', 'PENDING_DEBT', 'OVERDUE_DEBT'];
    if (statusData.status && !validStatuses.includes(statusData.status)) {
      errors.status = 'Estado inválido';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }

  // Determinar estado automático basado en montos y fechas
  determineAutomaticStatus(company) {
    const { pendingAmount, totalAmount, lastPayment } = company;
    
    // Si no hay monto pendiente, está al día
    if (pendingAmount === 0) {
      return 'UP_TO_DATE';
    }

    // Si hay monto pendiente, verificar si está vencido
    if (pendingAmount > 0) {
      // Aquí podrías agregar lógica para verificar fechas de vencimiento
      // Por ahora, asumimos que si hay deuda pendiente, está en estado de deuda pendiente
      return 'PENDING_DEBT';
    }

    return 'UP_TO_DATE';
  }

  // Obtener empresas que necesitan seguimiento
  async getCompaniesNeedingFollowUp() {
    try {
      const response = await AxiosConfig.get('/b2b/companies/follow-up');
      return response.data;
    } catch (error) {
      console.error('Error fetching companies needing follow-up:', error);
      throw error;
    }
  }

  // Enviar recordatorio de pago
  async sendPaymentReminder(companyId, reminderData) {
    try {
      const response = await AxiosConfig.post(`/b2b/companies/${companyId}/reminder`, reminderData);
      return response.data;
    } catch (error) {
      console.error('Error sending payment reminder:', error);
      throw error;
    }
  }
}

export default new CompanyStatusService();
